const apiResponseFormatter = {
    /**
     * @example isEmptyPartialDate({ "year": 0, "month": 0, "day": 0 }) = true
     */
    isEmptyPartialDate: (value) => !value || ((value === null || value === void 0 ? void 0 : value.day) === 0 && (value === null || value === void 0 ? void 0 : value.month) === 0 && (value === null || value === void 0 ? void 0 : value.year) === 0),
    /**
     * @example isEmptyString("") = true
     */
    isEmptyString: (value) => typeof value !== 'string' || value == '',
    /**
     * @example isEmptyEnumString("") = true
     * @example isEmptyEnumString("INCOME_SOURCE_UNSPECIFIED") = true
     * @example isEmptyEnumString("EMPLOYED") = false
     */
    isEmptyEnumString: (value) => typeof value !== 'string' || value === '' || value.includes('UNSPECIFIED'),
    /**
     * @example isEmptyUInt32(0) = true
     */
    isEmptyUInt32: (value) => typeof value !== 'number' || value === 0,
    /**
     * @example isEmptyInt64("") = true
     */
    isEmptyInt64: (value) => typeof value !== 'string' || value === '' || value === '0',
    /**
     * @example isEmptyMoney({ "amount": "0", "currencyCode": "USD" }) = true
     */
    isEmptyMoney: (value) => typeof value !== 'object' || !value.amount || value.amount === '0',
    /**
     * Unlike `isEmptyMoney`, a zero amount is a value: true only when there is no numeric amount to show.
     *
     * @example isMissingMoney({ "amount": "0", "currencyCode": "USD" }) = false
     * @example isMissingMoney({ "amount": "abc", "currencyCode": "USD" }) = true
     */
    isMissingMoney: (value) => typeof value !== 'object' ||
        value === null ||
        value.amount === undefined ||
        value.amount === null ||
        value.amount === '' ||
        Number.isNaN(Number(value.amount)),
    /**
     * @example isEmptyName({ "first": "", "middle": "", "last": "" }) = true
     */
    isEmptyName: (value) => typeof value !== 'object' ||
        (apiResponseFormatter.isEmptyString(value.first) &&
            apiResponseFormatter.isEmptyString(value.middle) &&
            apiResponseFormatter.isEmptyString(value.last)),
    /**
     * @example isEmptyAddress({ "addressLine1": "", "addressLine2": "", "city": "", "stateIso2Code": "", "postalCode": "", "countryIso2Code": "US" }) = true
     */
    isEmptyAddress: (value) => typeof value !== 'object' ||
        (apiResponseFormatter.isEmptyString(value.addressLine1) &&
            apiResponseFormatter.isEmptyString(value.addressLine2) &&
            apiResponseFormatter.isEmptyString(value.city) &&
            apiResponseFormatter.isEmptyString(value.stateIso2Code) &&
            apiResponseFormatter.isEmptyString(value.postalCode)),
};
export { apiResponseFormatter };
